<template>
  <bm-dropdown
    :auto-select-first="true"
    allow-custom-value
    v-bind="$attrs"
    :value="value"
    :items="countryNames"
    :filter-fields="[(item) => item.filterField]"
    :sort-items="false"
    autocomplete="off-should-mean-off-but-browsers-disagree"
    @change="bubbleInput"
  />
  <!-- Browsers have very selective behaviour for `autocomplete="off"`, so use a random string to completely prevent it instead -->
</template>

<script lang="ts">
import { getCountryNames } from "@/plugins/i18nCountries";
import userStore from "@/store/modules/userStore";
import { defineComponent } from "vue";

interface ICountry {
  filterField: string;
  text: string;
  value: string;
}

export default defineComponent({
  name: "BmCountry",
  props: {
    value: {
      type: String,
      required: false,
    },
  },
  computed: {
    countryNames(): ICountry[] {
      let countries: ICountry[] = [];
      let countryNames = getCountryNames(userStore.state.userLanguage);

      // Add the first value if exists
      let defaultCountryName = countryNames.find(
        (name) => name == userStore.state.country
      );

      if (defaultCountryName) {
        if (!Array.isArray(defaultCountryName)) {
          defaultCountryName = [defaultCountryName];
        }
        countries.push({
          filterField: defaultCountryName.join(" "),
          text: defaultCountryName[0],
          value: defaultCountryName[0],
        });
      }

      // Some countries contain multiple values so we take the first and use the others as filter values.
      countryNames
        .sort((a, b) => (a > b ? 1 : -1))
        .map((countryData) => {
          let items;
          if (Array.isArray(countryData)) {
            items = countryData;
          } else {
            items = [countryData];
          }

          countries.push({
            filterField: items.join(" "),
            text: items[0],
            value: items[0],
          });
        });

      return countries;
    },
  },
  methods: {
    bubbleInput(event: any) {
      this.$nextTick(() => this.$emit("input", event));
    },
  },
});
</script>
